<template>
  <div class="webcam-container">
    <div v-if="!capturedImage" class="video-wrapper">
      <video ref="video" autoplay playsinline class="video-preview"></video>
      <div class="video-overlay" v-if="!streamActive">
        <v-icon large color="grey">videocam_off</v-icon>
        <div class="caption grey--text mt-2">Kamera başlatılıyor...</div>
      </div>
    </div>
    <div v-else class="captured-wrapper">
      <img :src="capturedImage" class="captured-preview" />
    </div>
    <div class="controls mt-2 text-center">
      <v-btn v-if="!capturedImage" small color="teal" dark @click="capture" :disabled="!streamActive">
        <v-icon small left>camera_alt</v-icon>
        Fotoğraf Çek
      </v-btn>
      <v-btn v-else small color="orange" dark @click="retake">
        <v-icon small left>refresh</v-icon>
        Tekrar Çek
      </v-btn>
    </div>
    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
</template>

<script>
export default {
  name: "WebcamCapture",
  data() {
    return {
      streamActive: false,
      capturedImage: null,
      stream: null,
    };
  },
  mounted() {
    this.startCamera();
  },
  beforeDestroy() {
    this.stopCamera();
  },
  methods: {
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { width: 640, height: 480, facingMode: "environment" },
          audio: false,
        });
        this.$refs.video.srcObject = this.stream;
        this.streamActive = true;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Kamera erişim hatası:", err);
        this.streamActive = false;
      }
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
        this.streamActive = false;
      }
    },
    capture() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);
      this.capturedImage = canvas.toDataURL("image/jpeg", 0.85);
      this.$emit("captured", this.getBase64Data());
      this.stopCamera();
    },
    retake() {
      this.capturedImage = null;
      this.$emit("captured", null);
      this.$nextTick(() => {
        this.startCamera();
      });
    },
    getBase64Data() {
      if (!this.capturedImage) return null;
      // "data:image/jpeg;base64,..." kısmından base64 verisini ayıkla
      return this.capturedImage.split(",")[1];
    },
  },
};
</script>

<style scoped>
.webcam-container {
  width: 100%;
}
.video-wrapper {
  position: relative;
  width: 100%;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
  min-height: 200px;
}
.video-preview {
  width: 100%;
  display: block;
}
.video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.captured-wrapper {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid #00897b;
}
.captured-preview {
  width: 100%;
  display: block;
}
</style>
